import { Component, OnInit } from '@angular/core';
import { ProdutoService } from 'src/app/services/produto.service';
import { MatDialogRef } from '@angular/material';
import { FormUtil } from 'src/app/core/view/form-util';

@Component({
  templateUrl: './sincronizacao.component.html'
})
export class SincronizacaoComponent implements OnInit{
  filtro:any = {};
  dados = [];
  termo="";
  constructor(private dialogRef: MatDialogRef<SincronizacaoComponent>, private service:ProdutoService, private util:FormUtil) {
  }

  ngOnInit(){
    this.listarProdutos();
  }

  async listarProdutos(){
    try{
      const {resultado} = await this.service.importar().toPromise();
      this.dados = resultado;
    }catch(err){
      console.error(err);
    }
  }

  diferencas(produto){

    console.log(produto);
    const diff = produto.diferencas.length ? produto.diferencas.map(({key, older, newer}) => `${key} : ${ (typeof older == 'object') ? JSON.stringify(older) : older} => ${typeof newer == 'object' ? JSON.stringify(newer) : newer} `).reduce((a, b)=>`${a}<br>${b}`) : 'Sem diferenças';
    console.log(diff);

    this.util.view.showMessage(diff);
  }
 
  fechar = () => {
    this.dialogRef.close({});
  }
}
